export default __webpack_public_path__ + "static/media/solutionBG.d13c35de.svg";